module.exports = ".nova-logo{margin-top:15px}.welcome{font-weight:100;color:white;text-align:center;margin-top:-40px}.welcome .header{font-size:32px}.welcome .subheader{font-size:16px}.welcome #add-account button{border-radius:25px !important}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.style.scss
// module id = 657
// module chunks = 0